
import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';
import { calculateAgeWithTimezone, calculateAge } from '../../util/age-util';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactSettingComponent } from '@modal/contact-setting/contact-setting.component';
import { RegUser } from 'src/app/pages/basic-reg/RegUser';
import { AuthServiceService } from '@services/auth-service.service';
import { CommonUtil } from 'src/app/util/CommonUtil';

@Component({
  selector: 'app-profile-modal',
  templateUrl: './profile-modal.component.html',
  styleUrls: ['./profile-modal.component.scss' , '../../../assets/css/style.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule],
})
export class ProfileModalComponent implements OnInit {

  @Input("user") user!: RegUser;
  age: number | null = null;
  profileImageSrc: any;
  @Input("personalizedMsg") personalizedMsg!: any;
  @Input("isAddButtonVisible") isAddButtonVisible!: any;

  loggedInUser: RegUser = new RegUser();
  
  constructor(
    public activeModal: NgbActiveModal,
    public authService: AuthServiceService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.loggedInUser = this.authService.getLoggedInUser();
    if (this.user && this.user.birthDate && this.loggedInUser.timeZone) {
      this.age = calculateAgeWithTimezone(this.user.birthDate, this.loggedInUser.timeZone);
    } else if (this.user && this.user.birthDate) {
      this.age = calculateAge(this.user.birthDate);
    }
  }

  ionViewDidEnter() {
    // console.log("isAddButtonVisible: " + this.isAddButtonVisible);
  }
  dismiss(data: any) {
    this.activeModal.close(data);
  }

  openSettingModal(userData: any) {
    this.dismiss('');
    const modalRef = this.modalService.open(ContactSettingComponent, {
      centered: true,
      size: 'lg'
    });
    modalRef.componentInstance.user = userData;
    modalRef.componentInstance.personalizedMsg = this.personalizedMsg;
    modalRef.componentInstance.isSender = true;
    modalRef.componentInstance.isAddButtonVisible = this.isAddButtonVisible;

    modalRef.result.then((dataReturned) => {
      // this.router.navigateByUrl("dashboard");
    }).catch(() => {});
  }

}
